import { type FC } from "react";
import * as styles from "./styles.css";

export type StatusLabelProps = {
  premiumScoutFlag: boolean;
  newContentFlag: boolean;
  publishingEndUpCloseFlag: boolean;
  scoutFlag: boolean;
};

export const StatusLabels: FC<StatusLabelProps> = ({
  premiumScoutFlag,
  newContentFlag,
  publishingEndUpCloseFlag,
  scoutFlag,
}) => (
  <ul className={styles.labelList}>
    {premiumScoutFlag && (
      <li className={styles.labelListItem}>
        <span className={`${styles.label} ${styles.labelPremiumScout}`}>プレミアムスカウト</span>
      </li>
    )}
    {newContentFlag && (
      <li className={styles.labelListItem}>
        <span className={`${styles.label} ${styles.labelNew}`}>NEW</span>
      </li>
    )}
    {publishingEndUpCloseFlag && (
      <li className={styles.labelListItem}>
        <span className={`${styles.label} ${styles.labelNearEnd}`}>掲載終了間近</span>
      </li>
    )}
    {scoutFlag && !premiumScoutFlag && (
      <li className={styles.labelListItem}>
        <span className={`${styles.label} ${styles.labelScout}`}>スカウト</span>
      </li>
    )}
  </ul>
);
